/**
 * PATH: packages/ui/src/kanban/card-surface/details/CardDetailContributions.tsx
 * FILE_ID: UI-KANBAN-CARDSURFACE-DETAILS-001
 * PURPOSE: Compose visible card-detail contributions without empty wrappers.
 * WHY: Views declare content; the shared frame alone decides whether space exists.
 * FLOW: contribution list → visibility/renderability filter → node or null.
 * DEPENDENCIES: react; cardDetailContent.ts.
 * RELATED: components/KanbanCardDetailSlot.tsx; gantt-bucket/cardDetailSlot.tsx.
 */
import { Fragment, type ReactNode } from 'react'

import { hasRenderableCardDetail } from '../../components/cardDetailContent'

export interface CardDetailContribution {
  id: string
  visible: boolean
  content: ReactNode
}

export function composeCardDetailContributions(
  contributions: readonly CardDetailContribution[],
): ReactNode | null {
  const visible = contributions.filter(
    (contribution) =>
      contribution.visible && hasRenderableCardDetail(contribution.content),
  )
  if (visible.length === 0) return null

  return (
    <>
      {visible.map((contribution) => (
        <Fragment key={contribution.id}>{contribution.content}</Fragment>
      ))}
    </>
  )
}
